'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        filterField: {
            type: String,
            default: undefined,
            kComposite: 'filter.field'
        },
        filterFilters: {
            type: Array,
            default: undefined,
            kComposite: 'filter.filters'
        },
        filterLogic: {
            type: String,
            default: undefined,
            kComposite: 'filter.logic'
        },
        filterOperator: {
            type: [String, Function],
            default: undefined,
            kComposite: 'filter.operator'
        },
        filterValue: {
            type: [Object, Date, Number, String],
            default: undefined,
            kComposite: 'filter.value'
        }
    }
};